import { makeLMStyles } from "@launchmetrics/lm-ui";


export const useStyles = makeLMStyles(() => ({
	reportConfigurationTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: 'spacing-8'
	},
	reportConfigurationHeader: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 'spacing-8',
		flexDirection: 'column',
		justifyContent: 'space-evenly'
	},
	reportDropdownTitle: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		svg: {
			width: '20px',
			marginRight: '8px'
		}
	},
	disabledOption: {
		cursor: 'default',
		opacity: 0.5
	},
	reportForm: {
		selectorTitle: {
			position: 'relative',
			height: '32px',
			color: '#84848C',
			textTransform: 'uppercase',
			marginLeft: '10px !important',
			paddingTop: 'spacing-8',
			paddingLeft: 'spacing-8',
			paddingRight: 'spacing-8',
			paddingBottom: 'spacing-8',
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '16px',
			textAlign: 'left'
		},
		powerpoint: {
			feedClipping: {
				dropdown: {
					width: '350px'
				},
				count: {
					width: '104px'
				},
				remove: {
					marginTop: '4px',
					marginLeft: '8px'
				}
			},
			period: {
				tooltip: {
					width: '256px'
				}
			}
		},
		feedClippingLabel: { alignSelf: 'center', color: 'text.default' }
	}
}));
